import analysisChart from './analysis-chart.vue'
import manuscriptTask from './manuscript-task.vue'
import articalRanking from './artical-ranking.vue'
import journal from '@/api/journal'
import { statisticMcountry, statisticMtype } from '@/api/statistic'
import help from '@/utils/help'

export default {
  components: {
    analysisChart,
    manuscriptTask,
    articalRanking
  },
  data() {
    return {
      journalList: [],
      manuscriptType: {},
      titleTab: [
        { title: 'Yesterday', statu: 1 },
        { title: 'Latest 7 days', statu: 2 },
        { title: 'Latest 30 days', statu: 3 },
        { title: 'This year', statu: 4 }
      ],
      titleStatu: 1,
      params: {
        accessDateStart: this.$moment().subtract(1, 'days'),
        accessDateEnd: this.$moment()
      },
      articalTab: {
        Countries: 1,
        'Article Type': 2
      },
      articalStatu: 1
    }
  },
  computed: {},
  mounted() {
    this.getJournalList()
  },
  methods: {
    async getJournalList() {
      // this.journalList = await journal.userGet({ released: true })
      this.journalList = await journal.userGet({ released: true })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      if (!this.params.journalId) {
        return
      }
    },
    changejournal(val) {
      // console.log(val, 'val')
      this.params.journalId = val
      this.params = JSON.parse(JSON.stringify(this.params))
      localStorage.setItem('journalId', this.params.journalId)
    },
    changeArticalTime(val) {
      this.titleStatu = val
      switch (val) {
        case 1:
          this.params.accessDateStart = this.$moment().subtract(1, 'days')
          break
        case 2:
          this.params.accessDateStart = this.$moment().subtract(1, 'weeks')
          break
        case 3:
          this.params.accessDateStart = this.$moment().subtract(1, 'months')
          break
        case 4:
          this.params.accessDateStart = this.$moment().subtract(1, 'years')
          break
      }
      this.params.accessDateEnd = this.$moment()

      // console.log(this.params.accessDateStart, '开始时间')
      // console.log(this.params.accessDateEnd, '结束时间')
    },
    changeArtical(val) {
      this.articalStatu = val
    },
    async exportExl() {
      let res = ''
      if (this.articalStatu === 1) {
        res = await statisticMcountry.export(this.params)
        help.download(res.url, res.fileName)
      } else {
        res = await statisticMtype.export(this.params)
        help.download(res.url, res.fileName)
      }
    }
  }
}
